'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

require('../../styles/sections/index-slider.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('index-slider', {
  onLoad: function onLoad() {
    var container = this.container;
    this.slideshow = (0, _jquery2.default)(container).find('.slick-slider-wrapper');
    var sliderSize = (0, _jquery2.default)(this.slideshow).data('slider-size');

    this.settings = (0, _slick2.default)({
      dots: true,
      infinite: false,
      draggable: false,
      autoplay: false,
      slidesToShow: 1,
      centerMode: true,
      vertical: true,
      cssEase: 'ease',
      speed: 750,
      responsive: [{
        breakpoint: 650,
        settings: {
          dots: true,
          infinite: false,
          draggable: false,
          autoplay: false,
          slidesToShow: 1,
          centerMode: false,
          vertical: false,
          arrows: true,
          appendArrows: (0, _jquery2.default)('.slick-slider-wrapper').siblings('.slick-arrows')
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      }]

    });

    this.slideshow.slick(this.settings);

    this.slideshow.on('setPosition', function (event, slick) {
      var trigger = new Event('slick:resize');
      document.dispatchEvent(trigger);
    });

    this.slideshow.on('afterChange', function (event, slick) {
      updateSliderHeadings();
    });

    (0, _jquery2.default)('.slick-slider-wrapper').on('wheel', function (e) {
      e.preventDefault();
      if (e.originalEvent.deltaY < 0) {
        (0, _jquery2.default)(this).slick('slickPrev');
      } else {
        (0, _jquery2.default)(this).slick('slickNext');
      }
      // var sliderSize = $(this).slick("getSlick").slideCount;
      // var currentSliderIndex = $('.slick-slider-wrapper .slick-current').data('slick-index') + 1;
      // if (currentSliderIndex < sliderSize) {
      //   if (e.originalEvent.deltaY < 0) {
      //     $(this).slick('slickPrev');
      //   } else {
      //     $(this).slick('slickNext');
      //   }
      // }
      // else {
      //   $(this).off();
      // }
    });

    (0, _jquery2.default)('[data-scroll-anchor]').on('click', function (e) {
      e.preventDefault();
      var anchorId = (0, _jquery2.default)(this).data('scroll-to');
      console.log(anchorId);
      (0, _jquery2.default)('html, body').animate({
        scrollTop: (0, _jquery2.default)(anchorId).offset().top - 110
      }, 1000);
    });

    function updateSliderHeadings() {
      var currentSliderIndex = (0, _jquery2.default)('.slick-slider-wrapper .slick-current').data('slick-index') + 1;
      if (currentSliderIndex > 0) {
        for (var i = 1; i <= sliderSize; i++) {
          if (i <= currentSliderIndex) {
            (0, _jquery2.default)('[data-slider-index-' + i + ']').removeClass('hidden');
          } else {
            (0, _jquery2.default)('[data-slider-index-' + i + ']').addClass('hidden');
          }
        }
      }
    }

    var trigger = new Event('lazy:reload');
    document.dispatchEvent(trigger);
  },
  onUnload: function onUnload() {},
  onBlockSelect: function onBlockSelect(block, load) {
    var index = this.slideshow.find('[data-id="' + block + '"]').data('slick-index');
    this.slideshow.slick('goTo', index);
  }
});